import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import { Users, Sparkles, HeartHandshake } from 'lucide-react';

const pillars = [
  {
    icon: Users,
    title: 'Experienced Team',
    description: 'Built by professionals with deep expertise in payments, regulation and technology.'
  },
  {
    icon: Sparkles,
    title: 'Simplicity & Transparency',
    description: 'A powerful backend system that simplifies onboarding, payments and operations.'
  },
  {
    icon: HeartHandshake,
    title: 'Customer-Driven',
    description: 'Focused on delivering reliable and scalable infrastructure tailored to client needs.'
  }
];

export const WhyEasysend = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section 
      id="company" 
      className="py-16 lg:py-20 bg-[#E8E8E8] border-t border-[#D1D5DB]"
      data-testid="why-easysend-section"
    >
      <div className="section-container">
        {/* Section Header */}
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="mb-10"
        >
          <span className="label-text text-[#6B7280] block mb-4">
            Why Choose Us
          </span>
          <h2 
            className="heading-lg text-3xl md:text-4xl lg:text-5xl text-[#4FB3DF]"
            data-testid="why-easysend-title"
          >
            Why Easysend
          </h2>
        </motion.div>

        {/* Pillars Grid */}
        <div 
          className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#E5E7EB] border border-[#E5E7EB]"
          data-testid="pillars-grid"
        >
          {pillars.map((pillar, index) => (
            <motion.div
              key={pillar.title}
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ 
                duration: 0.6, 
                delay: index * 0.1, 
                ease: [0.22, 1, 0.36, 1] 
              }}
              className="bg-white p-8 lg:p-12"
              data-testid={`pillar-${index}`}
            >
              <pillar.icon 
                className="w-6 h-6 text-[#1E3A5F] mb-6" 
                strokeWidth={1.25} 
              />
              <h3 className="text-xl font-semibold text-[#1E3A5F] mb-4">
                {pillar.title}
              </h3>
              <p className="text-lg text-[#6B7280] leading-relaxed">
                {pillar.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
